import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Static fallback SEO tags in index.html are for non-JS clients; per-route tags come from react-helmet-async.
document.querySelectorAll("head [data-static-seo]").forEach((n) => n.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
